import { homeRoutes } from '../constants';

const HomeLayout = () => import('@/layouts/HomeLayout');
const CountrySelector = () => import('Features/home-mobile/components/CountrySelector');
const Home = () => import('Features/home-mobile/components/Home');

export const HomeRoutes = Object.freeze([
  {
    name: 'country',
    path: '/country',
    component: HomeLayout,
    meta: {
      requiresAuth: false
    },
    children: [
      {
        name: homeRoutes.countrySelector.name,
        path: homeRoutes.countrySelector.path,
        component: CountrySelector,
        meta: {
          requiresAuth: false,
          isStatusLayout: false,
          bizgainLayout: true
        }
      },
      {
        name: homeRoutes.home.name,
        path: homeRoutes.home.path,
        component: Home,
        meta: {
          requiresAuth: false,
          isStatusLayout: false,
          bizgainLayout: true
        }
      }
    ]
  }
])